
    var riot = require('riot')
    //src: starling/src/tags/menu/items/menu-item-create-relationship-card.html
riot.tag2('menu-item-create-relationship-card',
  '<i class="toolbar-icons add-card-relationship floating-menu_icon"></i> <span class="floating-menu_label">Add a card</span>',
  '',
  'class="floating-menu_item" onclick="{addCard}" onmouseenter="{hideSubMenus}"', function(opts) {
'use strict';

var _this = this;

var _util = require('lib/util');

var _menuUi = require('lib/menu-ui');

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

this.addCard = function () {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  _menuUi.mui.addCard.apply(_this, args);

  _eventTracking2.default.track({
    category: (0, _util.getTrackingLabel)(_this.parent),
    action: 'Add-Card-to-Relationship',
    label: 'Relationship'
  });
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('menu-item-create-relationship-card')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/menu/items/menu-item-create-relationship-card.html
// module id = 681
// module chunks = 0